export default __webpack_public_path__ + "static/media/0x60bb3d364b765c497c8ce50ae0ae3f0882c5bd05.fe3aff6b.png";